import { createFileRoute, redirect } from "@tanstack/react-router";
import { ARI_SITE_URL } from "@/features/company-story";

export const Route = createFileRoute("/ari/")({
    beforeLoad: ({ location }) => {
        throw redirect({
            href: `${ARI_SITE_URL}/${location.searchStr}`,
            statusCode: 308,
        });
    },
});
